module.exports=[
  {
    "specifics": "General story",
    "highlight": "The announcement came...released with letters of expulsion\"",
    "svg": "DL-1",
    "final_category": "Design/layout",
    "caption_popup": "Overall, this is a straight news story that should have been published on A1 in place of the humorous story and the story focusing on Jane Fonda. "
  },
  {
    "specifics": "\"120 Indians invaded the Seattle post\"",
    "highlight": "\"120 Indians invaded the Seattle post\"",
    "svg": "IL-1",
    "final_category": "Inaccurate language",
    "caption_popup": "The word \"invaded\" suggests military action. We would not use this word or we would ensure that it accurately described the events of the demonstration. (The Seattle Times collaborated with the United Indians of All Tribes Foundation to provide context for this annotation.)"
  },
  {
    "specifics": "\"The Indians are acting under the name of...\" ",
    "highlight": "\"The Indians\"",
    "svg": "IL-2",
    "final_category": "Inaccurate language",
    "caption_popup": "The story frequently refers to the demonstrators as \"the Indians,\" calling all participants by a racial identity instead of their actions and cause. "
  },
  {
    "specifics": "\"The Indians contend they have a legal right to any unused native lands\"",
    "highlight": "\"The Indians contend they have a legal right to any unused native lands\"",
    "svg": "LI-1",
    "final_category": "Lack of information/underreporting",
    "caption_popup": "The story does not explain Native sovereignty, land rights, treaty failures, forced removal or genocide, all of which are important background information to understand the context for the demonstration. "
  },
  {
    "specifics": "\"Court action to investigate Indian charges of brutality against military police was being considered by Indians\" ",
    "highlight": "\"Court action to investigate Indian charges of brutality against military police was being considered by Indians\" ",
    "svg": "LI-2",
    "final_category": "Lack of information/underreporting",
    "caption_popup": "This sentence needs more information: Who specifically is considering pressing charges and why?"
  },
  {
    "specifics": "\"blamed violence yesterday on military personnel\"",
    "highlight": "\"blamed violence yesterday on military personnel\"",
    "svg": "LI-3",
    "final_category": "Lack of information/underreporting",
    "caption_popup": "We expect a reporter today to substantiate this claim with details and descriptions from demonstrators and military police about what happened."
  },
  {
    "specifics": "\"contending that at least 10 Indians required hospital treatment\" ",
    "highlight": "\"contending that at least 10 Indians required hospital treatment\" ",
    "svg": "LI-4",
    "final_category": "Lack of information/underreporting",
    "caption_popup": "We would call hospitals to confirm that demonstrators had required hospitalization, rather than rely on a source's claim."
  },
  {
    "specifics": "\"The Indian claim here has been made in the same spirit\" ",
    "highlight": "\"The Indian claim here has been made in the same spirit\" ",
    "svg": "LI-5",
    "final_category": "Lack of information/underreporting",
    "caption_popup": "We would expect a reporter today to include more quotes and information about the demonstrators' objectives higher up in the story."
  },
  {
    "specifics": "Military authorities were expecting another influx of Indians at Fort Lawton today.\" ",
    "highlight": "were expecting ",
    "svg": "LI-6",
    "final_category": "Lack of information/underreporting",
    "caption_popup": "This mention of the military authorities' expectations needs to be backed up with facts.\n"
  },
  {
    "specifics": "Military authorities were expecting another influx of Indians at Fort Lawton today.\"",
    "highlight": "influx of Indians",
    "svg": "OL-1",
    "final_category": "Offensive language",
    "caption_popup": "The use of the word \"influx\" is demeaning and dismissive."
  },
  {
    "specifics": "\"Indians 'invade' army posts\"",
    "highlight": "headline",
    "svg": "RL-1",
    "final_category": "Racist language",
    "caption_popup": "The word \"invade\" uses a racist stereotype about Indigenous history. It is also not known who is being quoted. We would attribute it to the source and consider not using it even in quotes. (The Seattle Times collaborated with the United Indians of All Tribes Foundation to provide context for this annotation.)"
  },
  {
    "specifics": "\"The announcement came in the wake of 'invasions' yesterday of both Fort Lewis and Fort Lawton\" ",
    "highlight": "\"The announcement came in the wake of 'invasions' yesterday of both Fort Lewis and Fort Lawton\"",
    "svg": "RL-2",
    "final_category": "Racist language",
    "caption_popup": "The word \"invade\" uses a racist stereotype about Indigenous history. It is also not known who is being quoted. We would attribute it to the source and consider not using it even in quotes. "
  },
  {
    "specifics": "\"Miss Thorpe was among the invaders...\"",
    "highlight": "\"invaders\"",
    "svg": "RL-3",
    "final_category": "Racist language",
    "caption_popup": "\"Invaders\" is racist in this context and a mischaracterization of the demonstrators. (The Seattle Times collaborated with the United Indians of All Tribes Foundation to provide context for this annotation.)"
  }
]